import store from './store'
import { bugsnagClient } from '@/services/ErrorHandler'
import { isPast, parse } from 'date-fns'

export const falseRoute = (from) => from.name === null ? { name: 'home' } : false

/**
 * Fetch the Logged in user immediately when we enter
 * @returns {Promise<boolean>}
 */
export async function fetchLoggedUserGuard (to, from, next) {
  if (store.getters['auth/isLoggedIn'] && !store.getters['user/user']) {
    try {
      const user = await store.dispatch('user/fetchUser')
      bugsnagClient.user = {
        id: user.id,
        name: user.full_name,
        email: user.email
      }
    } catch (e) {
      next(false)
    }
  }
  return next()
}

/**
 * Authentication guard
 * @param to
 * @returns {Promise<boolean>}
 */
export async function authGuard (to) {
  const guardedRoute = to.matched.slice(0).reverse().find(route => route.meta.hasOwnProperty('auth'))
  if (!guardedRoute) return true
  const authMeta = guardedRoute.meta.auth
  if (typeof authMeta === 'boolean') {
    return authMeta === store.getters['auth/isLoggedIn']
  }
  if (typeof authMeta === 'string') {
    return store.getters['user/user'].role === authMeta
  }
}

/**
 * Limit the access only to the admin accounts
 * @param to
 * @param from
 * @param next
 * @returns {*}
 */
export function adminOnly (to, from, next) {
  return store.getters['user/isAdmin'] ? next() : next(falseRoute(from))
}

export function showCountdownTimer (to, from, next) {
  const past = isPast(parse(process.env.VUE_APP_RELEASE_ON))
  if (to.name === 'countdown') return past ? next({ name: 'home' }) : next()
  return past ? next() : next({ name: 'countdown' })
}
